<template>
  <div class="uploadbj">
    <div class="yhome_warp">
        <el-page-header @back="goBack" class="header"></el-page-header>
      <div class="title">人口抽样调查采集与分析数据Excel数据导入</div>
      <div class="fromData">
        	<el-upload
                ref="upload"
                class="filter-item"
                action="http://81.68.152.108:6477/phe-api/poresidence/importData" 
                :before-upload="beforeUpload"
                type="primary"
                :on-change="uploadExcel"
                :show-file-list="false"
                :file-list="fileList"
                :limit="limitUpload" 
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                :auto-upload="false"
              >
                <el-button type="primary" size="mini" icon="el-icon-bottom-right">Excel导入</el-button>
   </el-upload>

      </div>
    </div>
  </div>
</template>

<script>
import { uploadExcel } from "@/network";
export default {
    data() {
      return {
        fileList: [], //上传的文件列表, 例如: [{name: 'food.jpg', url: 'https://xxx.cdn.com/xxx.jpg'}]
        limitUpload: 100, //允许上传次数（不刷新页面情况下）
      }
    },
    methods: {
     //上传前校验(其实如果在accept中限制了格式，这一步可有可无---)
      beforeUpload(file) {
        // 文件大小限制为2M
        const fileLimit = file.size / 1024 / 1024 < 2
        if (!fileLimit) {
          this.$message.error('上传文件大小不超过2M！')
        }
        return fileType && fileLimit
      },
      // excel表上传（方法调用在此方法中）
      uploadExcel(file) {
        const fileTemp = file.raw
        const fileName = file.raw.name
        const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
        // 判断上传文件格式
        if (fileTemp) {
          if ((fileType === 'xlsx') || (fileType === 'xls')) {
            const formData = new FormData() 
            formData .append('uploadFile', file.raw)
            crudUser.uploadExcel(uploadExcel ).uploadExcel(res => { //调用接口，传递参数
              this.crud.refresh() //这里是封装的刷新方法，可以无刷新更新页面数据
              this.$message({
                message: res,//这里是后端返回的提示文字---
                type: 'success'
              })
            })
          } else {
            this.$message({
              type: 'warning',
              message: '附件格式错误，请重新上传！'
            })
          }
        } else {
          this.$message({
            type: 'warning',
            message: '请上传附件！'
          })
        }
      },
      

      goBack() {
        console.log('go back');
        window.history.go(-1);
      },
    }
  }
</script>

<style scoped lang="less">
.uploadbj {
    width: 100%;
    height: 100%;
    background: #2b5cd0;
    // margin: -20px 20px 0 -20px;
  .yhome_warp {
    width: 800px;
    height: 500px;
    background: #071755;
    border: 1px solid #000000;
    opacity: 0.86;
    margin: 0 auto;
    border-radius: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    right: 50%;
    transform: translate(-50%, -50%);
    .title {
      width: 250px;
      margin: 30px auto 0px;
      font-size: 22px;
      text-align: center;
      font-family: PingFang SC;
      font-weight: bold;
      color: #01cefb;
    }
    .header{
        color: #fff;
        margin: 20px;
    }
  }
  .fromData {
    width: 400px;
    margin: 0 auto;
    padding: 80px 0 80px 0;
    .upload{
      margin: 0 0 0 110px;
    }
  }
  
}
</style>
